import type { Box } from 'graphql-models';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_BOX: Box = {
  createdAt: new Date('Mon Feb 21 2024 15:15:35 GMT+0100').toISOString(),
  deviceId: 'aaaaa-bbbbbb',
  id: '1',
  reportedLocked: true,
  reportedPin: '121344',
  reportedClosed: true,
  updatedAt: new Date('Mon Feb 21 2025 15:15:35 GMT+0100').toISOString(),
  reportedFirmwareVersion: '1.4.0',
  reportedState: 'ACTIVE',
};

export const boxFactory: Factory<Box> = (overrides) => ({
  ...MOCK_BOX,
  ...overrides,
});
